module.exports = __webpack_public_path__ + "img/weatherbg.2df10cab.jpg";